import humps from 'humps'
// import inflect from 'i';
import { axios } from '../request'
import { toRaw } from 'vue'

// const inflect = require('i')(true);

function processParams(params) {
  const p = JSON.parse(JSON.stringify(params))
  if (typeof params.sort.name === 'undefined') {
    p.sortName = 'created_at'
  } else {
    p.sortName = params.sort.name
  }
  if (typeof params.sort.direction === 'undefined') {
    p.sortDir = ''
  } else if (params.sort.direction === 'ascending') {
    p.sortDir = ''
  } else {
    p.sortDir = '-'
  }
  if (typeof params.page === 'undefined') {
    p.page = -1
  }
  // TODO: IS THIS UNUSED?
  /* if (typeof params.query === 'undefined') {
    p.query = ''
  } */
  let constrains = ''
  if (typeof params.constrains !== 'undefined' && p.constrains !== '') {
    Object.keys(params.constrains).forEach((key) => {
      constrains += `&_${key}=${params.constrains[key]}`
    })
  }
  p.constrains = constrains
  return p
}

function preRequestTransform(item, state) {
  //so we can change values before submiting without changing frontend values. Useful for typecasting
  const newItem = structuredClone(toRaw(item))
  const structure = state.structure
  Object.keys(newItem).forEach((key) => {
    if (typeof structure[key] !== 'undefined') {
      if (structure[key].type === 'float32') {
        newItem[key] = parseFloat(newItem[key])
      } else if (structure[key].type === 'integer') {
        newItem[key] = parseInt(newItem[key], 10)
      }
    }
  })
  return newItem
}

function storedListSize(name) {
  let listSize = 100
  if (localStorage.getItem(`${name}ListSize`)) {
    localStorage.removeItem(`${name}ListSize`)
  }
  /*const newSize = localStorage.getItem(`${name}ListSize`)
  if (newSize !== null) {
    listSize = parseInt(newSize, 10)
  }*/
  return listSize
}
function getListFields(name) {
  if (!sessionStorage.getItem(`${name}ListFields`)) {
    return {}
  } else {
    return JSON.parse(sessionStorage.getItem(`${name}ListFields`))
  }
}
function getSortOrder(name) {
  if (!sessionStorage.getItem(`${name}SortOrder`)) {
    return {
      name: 'name',
      direction: 'ascending',
    }
  } else {
    return JSON.parse(sessionStorage.getItem(`${name}SortOrder`))
  }
}

export default function generateStore(name) {
  const url = humps.decamelize(name)
  let listRequestAbortController = null

  return {
    namespaced: true,
    state: {
      cache: {
        data: {},
        pages: {},
      },
      listById: {},
      list: [{}],
      listUnpaginated: [{}],
      loading: false,
      loaded: false,
      loadingUnpaginated: false,
      loadedUnpaginated: false,
      errors: [],
      triedSaving: false,
      total: 0,
      structure: {},
      listSize: storedListSize(name),
      status: null,
      params: {
        page: 1,
        search: '',
        sort: getSortOrder(name),
        constrains: {},
      },
      listFields: getListFields(name),
    },
    mutations: {
      clearList(state) {
        state.list = [{}]
        state.listById = {}
      },
      addEmpty(state) {
        state.list.push({})
      },
      setLastStatus(state, s) {
        state.status = s
      },
      setSingle(state, { key, data }) {
        state.list[key] = data
        state.listById[data._id] = data
        data._k = key
      },
      saveCache(state, { fullURL, data }) {
        const ids = []
        state.cache.pages[fullURL] = []
        data.data.forEach((item) => {
          state.cache.data[item['_id']] = item
          ids.push(item['_id'])
        })
        state.cache.pages[fullURL] = ids
      },
      clearCachePage(state, fullURL) {
        if (typeof state.cache.pages[fullURL] !== 'undefined') {
          delete state.cache.pages[fullURL]
        }
      },
      appendToList(state, list) {
        if (Object.keys(state.list[0]) <= 1) {
          state.list = []
        }
        state.list.push(...list)
        list.forEach((item) => {
          state.listById[item._id] = item
        })
      },
      setList(state, list) {
        state.list = list
        const listById = {}
        list.forEach((item) => {
          listById[item._id] = item
        })
        state.listById = listById
      },
      setIndexes(state) {
        state.list.forEach((item, k) => {
          item._k = k
        })
      },
      setListUnpaginated(state, list) {
        state.listUnpaginated = list
      },
      setListSize(state, listSize) {
        let s = 0
        if (listSize === 0) {
          s = 1
        } else if (listSize > 500) {
          s = 500
        } else {
          s = listSize
        }

        if (listSize !== -1) {
          localStorage.setItem(`${name}ListSize`, s)
        }
        if (listSize === -1) {
          s = -1
        }
        state.listSize = s
      },
      setListFields(state, fields) {
        fields.forEach((field) => {
          state.listFields[field.name] = field.visible
        })
        sessionStorage.setItem(`${name}ListFields`, JSON.stringify(state.listFields))
      },
      setTotal(state, total) {
        state.total = total
      },
      setErrors(state, { key, payload }) {
        if (typeof payload !== 'undefined') {
          state.errors[key] = payload
        }
      },
      clearErrors(state) {
        state.errors = []
      },
      loading(state) {
        Object.assign(state, { loaded: false, loading: true })
      },
      loaded(state) {
        Object.assign(state, { loaded: true, loading: false })
      },
      notLoaded(state) {
        Object.assign(state, { loaded: false, loading: false })
      },
      loadingUnpaginated(state) {
        Object.assign(state, { loadedUnpaginated: false, loadingUnpaginated: true })
      },
      loadedUnpaginated(state) {
        Object.assign(state, { loadedUnpaginated: true, loadingUnpaginated: false })
      },
      removeFromList(state, k) {
        const id = state.list[k]._id
        delete state.listById[id]
        state.list.splice(k, 1)
        if (state.list.length === 0) {
          state.list = [{}]
        }
      },
      setTriedSaving(state, v) {
        Object.assign(state, { triedSaving: v })
      },
      setFormValue(state, { key, fieldName, fieldValue }) {
        let k = key
        if (typeof k === 'undefined') {
          k = 0
        }
        if (typeof state.list[k] === 'undefined') {
          state.list[k] = {}
        }
        state.list[k][fieldName] = fieldValue
      },
      setParam(state, params) {
        Object.keys(params).forEach((paramName) => {
          state.params[paramName] = params[paramName]
          if (paramName === 'sort') {
            sessionStorage.setItem(`${name}SortOrder`, JSON.stringify(params[paramName]))
          }
        })
      },
      setConstrain(state, constrains) {
        Object.keys(constrains).forEach((constrainName) => {
          if (typeof constrains[constrainName] === 'undefined') {
            delete state.params.constrains[constrainName]
          } else {
            state.params.constrains[constrainName] = constrains[constrainName]
          }
        })
      },
      clearConstrains(state) {
        state.params.constrains = {}
      },
      setStructure(state, payload) {
        const structure = {}
        payload.forEach((item) => {
          structure[item.name] = {
            type: item.type,
            validation: item.validation,
            label: item.label,
            group: item.group,
            inputType: item.inputType,
          }
        })
        state.structure = structure
      },
    },
    actions: {
      addEmpty(context) {
        return new Promise((resolve) => {
          context.commit('addEmpty')
          context.commit('setIndexes')
          resolve(context.state.list[context.state.list.length - 1])
        })
      },
      clearList(context) {
        return new Promise((resolve) => {
          if (listRequestAbortController !== null) {
            if (!listRequestAbortController.signal.aborted) {
              listRequestAbortController.abort()
            }
          }

          context.commit('clearList')
          context.commit('setIndexes')
          context.dispatch('setTriedSaving', false)
          resolve()
        })
      },
      saveAllVia(context, { resource, id }) {
        return new Promise((resolve, reject) => {
          const urlPrefix = `/${resource}/${id}/`
          context
            .dispatch('saveAll', { urlPrefix })
            .then(() => {
              resolve()
            })
            .catch((err) => {
              reject(new Error('Cannot save all via', context, err))
            })
        })
      },
      saveAll(context, { urlPrefix }) {
        const promises = []
        context.state.list.forEach((v, key) => {
          promises.push(context.dispatch('save', { key, urlPrefix }))
        })
        return Promise.all(promises)
      },
      save(context, { key, urlPrefix }) {
        return new Promise((resolve, reject) => {
          let k = key
          if (typeof key === 'undefined') {
            k = 0
          }
          if (typeof context.state.list[k]._id !== 'undefined') {
            context
              .dispatch('update', { key: k, urlPrefix })
              .then((data) => {
                //context.commit('setSingle', { key: k, data: res.data.data })
                resolve(data)
              })
              .catch((err) => reject(new Error('Update failed ' + err)))
          } else {
            context
              .dispatch('create', { key: k, urlPrefix })
              .then((data) => {
                resolve(data)
              })
              .catch((err) => reject(new Error('Create failed ' + err)))
          }
        })
      },
      create(context, { key, urlPrefix }) {
        return new Promise((resolve, reject) => {
          context.dispatch('setTriedSaving', true)
          let p = urlPrefix
          if (typeof urlPrefix === 'undefined') p = ''
          axios
            .post(`${p}${url}`, preRequestTransform(context.state.list[key], context.state))
            .then((res) => {
              context.commit('setErrors', { key, payload: {} })
              context.commit('setLastStatus', res.status)
              context.commit('setSingle', { key, data: res.data.data })
              context.commit('setIndexes')
              context.dispatch('setTriedSaving', false)
              resolve(res.data.data)
            })
            .catch((err) => {
              context.commit('setErrors', { key, payload: err.response.data.errors })
              context.commit('setLastStatus', err.response.status)
              reject(new Error(err))
            })
        })
      },
      list(context, options) {
        let append = false
        if (typeof options !== 'undefined') {
          if (options.append) {
            append = true
          }
        }
        if (listRequestAbortController !== null) {
          if (listRequestAbortController.signal.aborted) {
            listRequestAbortController.abort()
          }
        }
        listRequestAbortController = new AbortController()
        return new Promise((resolve) => {
          // context.commit('setList', [{}])
          const params = context.state.params
          const p = processParams(params)
          p.signal = listRequestAbortController.signal
          const limit = context.state.listSize
          context.commit('loading')
          const fullURL = `${url}?_page=${p.page}&_limit=${limit}&_sort=${p.sortDir}${p.sortName}&_search=${params.search}${p.constrains}`
          // loadCache
          if (typeof context.state.cache.pages[fullURL] !== 'undefined') {
            context.commit('clearErrors')
            const data = []
            context.state.cache.pages[fullURL].forEach((id) => {
              data.push(context.state.cache.data[id])
            })
            if (!append) {
              context.commit('setList', data)
            } else {
              context.commit('appendToList', data)
            }
            context.commit('setIndexes')
          }
          axios
            .get(fullURL, p)
            .then((res) => {
              listRequestAbortController = null
              context.commit('clearErrors')
              context.commit('saveCache', { fullURL, data: res.data })
              if (!append) {
                context.commit('setList', res.data.data)
              } else {
                context.commit('appendToList', res.data.data)
              }
              context.commit('setIndexes')
              context.commit('setTotal', res.data.meta.total)
              context.commit('loaded')
              context.commit('setLastStatus', res.status)
              resolve(res.data.data)
            })
            .catch((err) => {
              listRequestAbortController = null
              context.commit('clearCachePage', fullURL)
              context.commit('clearErrors')
              if (err.response) {
                context.commit('setLastStatus', err.response.status)
                context.commit('setList', [{}])
                if (err.response.status === 404) {
                  context.commit('loaded')
                  resolve()
                }
              } else {
                context.commit('notLoaded')
              }
            })
        })
      },
      listUnpaginated(context) {
        return new Promise((resolve) => {
          if (listRequestAbortController !== null) {
            if (listRequestAbortController.signal.aborted) {
              listRequestAbortController.abort()
            }
          }
          listRequestAbortController = new AbortController()
          const params = context.state.params
          const p = processParams(params)
          p.signal = listRequestAbortController.signal
          context.commit('loadingUnpaginated')
          const fullURL = `${url}?_page=1&_limit=-1&_sort=${p.sortDir}${p.sortName}&_search=${params.search}${p.constrains}`
          axios
            .get(fullURL, p)
            .then((res) => {
              context.commit('clearErrors')
              context.commit('setListUnpaginated', res.data.data)
              context.commit('loadedUnpaginated')
              context.commit('setLastStatus', res.status)
              resolve()
            })
            .catch((err) => {
              context.commit('clearErrors')
              context.commit('setLastStatus', err.response.status)
              if (err.response.status === 404) {
                context.commit('loaded')
                resolve()
              } else {
                context.commit('notLoaded')
              }
            })
        })
      },
      clearUnpaginated(context) {
        context.commit('setListUnpaginated', [{}])
      },
      listFrom(context, { resource, id, append }) {
        return new Promise((resolve) => {
          context.commit('loading')
          axios
            .get(`/${resource}/${id}/${url}`)
            .then((res) => {
              if (append) {
                context.commit('appendToList', res.data.data)
              } else {
                context.commit('setList', res.data.data)
              }
              context.commit('setIndexes')
              context.commit('setTotal', res.data.meta.total)
              context.commit('loaded')
              resolve(res.data.data)
            })
            .catch((err) => {
              context.commit('setList', [])
              if (err.response) {
                if (err.response.status === 404) {
                  context.commit('loaded')
                  resolve()
                }
              } else {
                context.commit('notLoaded')
                resolve()
              }
            })
        })
      },
      read(context, params) {
        //can have id or {id: v, append: bool}
        return new Promise((resolve, reject) => {
          let id
          let key = 0
          if (typeof params === 'object' && !Array.isArray(params) && params !== null) {
            id = params.id
          } else {
            id = params
          }
          context.commit('setErrors', { key, payload: {} })
          context.commit('notLoaded')
          if (typeof id === 'undefined') {
            reject(new Error(`missing id when calling read on ${url}`))
            return
          }
          context.commit('loading')
          /* if (typeof context.state.listById[id] !== 'undefined') {
            context.commit('setSingle', {key, data: context.state.listById[id]});
            context.commit('loaded');
          } */
          axios
            .get(`${url}/${id}`)
            .then((res) => {
              if (params.append) {
                key = context.state.list.length
                if (context.state.list.length === 1) {
                  if (Object.keys(context.state.list[0]).length === 0) {
                    key = 0
                  }
                }
              }
              context.commit('clearErrors')
              context.commit('setSingle', { key, data: res.data.data })
              context.commit('setIndexes')
              context.commit('loaded')
              context.commit('setLastStatus', res.status)
              resolve(res.data.data)
            })
            .catch((err) => {
              context.commit('clearErrors')
              context.commit('setSingle', { key, data: {} })
              if (err.response) {
                context.commit('setLastStatus', err.response.status)
                if (err.response.status === 404) {
                  context.commit('loaded')
                  resolve()
                }
              } else {
                context.commit('notLoaded')
                resolve()
              }
              reject(new Error('Could not read item'))
            })
        })
      },
      update(context, { key, urlPrefix }) {
        return new Promise((resolve, reject) => {
          context.dispatch('setTriedSaving', true)
          let p = urlPrefix
          if (typeof urlPrefix === 'undefined') {
            p = ''
          }
          const fullurl = `${p}${url}/${context.state.list[key]._id}`
          axios
            .put(fullurl, preRequestTransform(context.state.list[key], context.state))
            .then((res) => {
              context.commit('setErrors', { key, payload: {} })
              context.commit('setSingle', { key, data: res.data.data })
              context.commit('setIndexes')
              context.commit('setLastStatus', res.status)
              context.dispatch('setTriedSaving', false)
              resolve(res.data.data)
            })
            .catch((err) => {
              context.commit('setLastStatus', err.response.status)
              context.commit('setErrors', { key, payload: err.response.data.errors })
              reject(new Error('Failed to Update'))
            })
        })
      },
      modify(context, { key, fields, urlPrefix }) {
        return new Promise((resolve, reject) => {
          context.dispatch('setTriedSaving', true)
          let p = urlPrefix
          if (typeof urlPrefix === 'undefined') p = ''
          let k = key
          if (typeof k === 'undefined') k = 0

          let updateObject = {}
          if (typeof fields === 'undefined') {
            updateObject = preRequestTransform(context.state.list[k], context.state)
          } else {
            // updateObject.id = context.state.list[key]._id;
            fields.forEach((field) => {
              updateObject[field] = context.state.list[k][field]
            })
          }

          axios
            .patch(`${p}${url}/${context.state.list[k]._id}`, updateObject)
            .then((res) => {
              context.commit('setErrors', { key: k, payload: {} })
              context.commit('setSingle', { key: k, data: res.data.data })
              context.commit('setIndexes')
              context.dispatch('setTriedSaving', false)
              resolve()
            })
            .catch((err) => {
              context.commit('setErrors', { key: k, payload: err.response.data.errors })
              reject(new Error('Failed to modify'))
            })
        })
      },
      deleteAll(context) {
        const promises = []
        context.state.list.forEach((v, key) => {
          promises.push(context.dispatch('delete', key))
        })
        return Promise.all(promises)
      },

      delete(context, k) {
        return new Promise((resolve, reject) => {
          const id = context.state.list[k]._id
          if (typeof id !== 'undefined') {
            axios
              .delete(`${url}/${id}`)
              .then(() => {
                context.commit('removeFromList', k)
                context.commit('setIndexes')
                resolve()
                context.dispatch('validate')
              })
              .catch(() => {
                reject(new Error('failed to delete'))
              })
          } else {
            context.commit('removeFromList', k)
            context.commit('setIndexes')
            resolve()
            context.dispatch('validate')
          }
        })
      },
      validate(context, key) {
        return new Promise((resolve, reject) => {
          if (typeof key !== 'undefined') {
            if (typeof context.state.list[key] !== 'undefined') {
              axios
                .post(
                  `${url}/validate`,
                  preRequestTransform(context.state.list[key], context.state)
                )
                .then((res) => {
                  context.commit('setErrors', { key, payload: {} })
                  context.commit('setLastStatus', res.status)
                  resolve()
                })
                .catch((err) => {
                  if (err.response) {
                    context.commit('setErrors', { key, payload: err.response.data.errors })
                    context.commit('setLastStatus', err.response.status)
                    reject()
                  }
                })
            }
          } else {
            context.commit('clearErrors')
            context.state.list.forEach((_, key) => {
              axios
                .post(
                  `${url}/validate`,
                  preRequestTransform(context.state.list[key], context.state)
                )
                .then((res) => {
                  context.commit('setErrors', { key, payload: {} })
                  context.commit('setLastStatus', res.status)
                })
                .catch((err) => {
                  if (err.response) {
                    context.commit('setErrors', { key, payload: err.response.data.errors })
                    context.commit('setLastStatus', err.response.status)
                  }
                })
            })
          }
        })
      },
      setTriedSaving(context, payload) {
        context.commit('setTriedSaving', payload)
      },
      setFormValue(context, payload) {
        context.commit('setFormValue', payload)
        if (typeof payload.key !== 'undefined' && !payload.skipValidation) {
          context.dispatch('validate', payload.key).catch(() => {})
        }
      },
      setParam(context, payload) {
        context.commit('setParam', payload)
      },
      setConstrain(context, payload) {
        context.commit('setConstrain', payload)
      },
      clearConstrains(context) {
        context.commit('clearConstrains')
      },
      explain(context, data) {
        context.commit('setStructure', data)
        /*return new Promise((resolve, reject) => {
          axios
            .get(`${url}/explain`)
            .then((res) => {
              context.commit('setStructure', res.data.data)
              resolve()
            })
            .catch((err) => {
              context.commit('setStructure', [])
              if (typeof err.response !== 'undefined') {
                if (err.response.status === 404) {
                  reject(new Error('Explain not found'))
                }
              }
            })
        })*/
      },
      setListSize(context, size) {
        context.commit('setListSize', size)
      },
      setListFields(context, fields) {
        context.commit('setListFields', fields)
      },
    },
    getters: {
      errorCount(state) {
        let c = 0
        state.errors.forEach((item) => {
          Object.keys(item).forEach((k) => {
            c += 1
          })
        })
        return c
      },
    },
  }
}
